import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import SalesTargetActions from "../../../../reducers/modules/sales/sales-target/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "sales/sales-target";

export default class SalesTargetMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(SalesTargetActions.create());
    };
  }

  static createTarget() {
    return (dispatch) => {
      dispatch(SalesTargetActions.createTarget());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(SalesTargetActions.update());
      SalesTargetMiddleware.showOne(dispatch, params);
    };
  }

  static updateTarget(params) {
    return (dispatch) => {
      dispatch(SalesTargetActions.update());
      SalesTargetMiddleware.showOneTarget(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(SalesTargetActions.process());
      SalesTargetMiddleware.showlist(dispatch, params);
    };
  }
  static listAssign(params) {
    return (dispatch) => {
      dispatch(SalesTargetActions.process());
      SalesTargetMiddleware.showlistAssign(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(SalesTargetActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(SalesTargetActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(SalesTargetActions.view());
      SalesTargetMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(SalesTargetActions.submit());
      SalesTargetMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveNewAssign(post, search) {
    return (dispatch) => {
      dispatch(SalesTargetActions.submit());
      SalesTargetMiddleware.saveNewAssign(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(SalesTargetActions.submit());
      SalesTargetMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(SalesTargetActions.beforePrint());
      SalesTargetMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(SalesTargetActions.delete());
      SalesTargetMiddleware.delete(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      SalesTargetMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      SalesTargetMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-cashbank-book",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesTargetActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesTargetActions.list(response.data.result));
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlistAssign(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "sales/target-assignment",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesTargetActions.listAssign(response.data.result));
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }
  
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-sales-order",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesTargetActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }
  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesTargetActions.print(response.data.result));
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesTargetActions.view(response.data.result));
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOneTarget(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalesTargetActions.viewTarget(response.data.result));
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            SalesTargetActions.process(),
            SalesTargetMiddleware.showlist(dispatch, params)
          );
          SalesTargetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            SalesTargetActions.process(),
            SalesTargetMiddleware.showlist(dispatch, search)
          );
          dispatch(SalesTargetActions.success());
          SalesTargetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }


  static saveNewAssign(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "sales/target-assignment",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            SalesTargetActions.process(),
            SalesTargetMiddleware.showlistAssign(dispatch, search)
          );
          dispatch(SalesTargetActions.success());
          SalesTargetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${SalesTargetMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            SalesTargetActions.process(),
            SalesTargetMiddleware.showlist(dispatch, search)
          );
          dispatch(SalesTargetActions.success());
          SalesTargetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        SalesTargetMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(SalesTargetActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(SalesTargetActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
